/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { fetchTinybird } from "#web/services/tinybird";
import * as v from "valibot";

import { Order } from "../_models/ordersUsingCodeWithinWeek";
import { CodeUsageReader, getOrdersUsingCodeWithinDateRangeInput } from "./service";

export const tinybirdCodeUsageReader = (): CodeUsageReader => {
  const getOrdersUsingCodeWithinDateRange = async (input: getOrdersUsingCodeWithinDateRangeInput) => {
    return await fetchTinybird("orders_using_code_within_date_range", {
      code: input.code,
      endDate: input.dateRange.end,
      shopId: input.shopId,
      startDate: input.dateRange.start,
    })
      .then((r) => {
        // tinybird is not really typed
        // @see <TINYBIRD_APP>/pipe/orders_using_code_within_date_range
        const orders = r.data;
        return v.parse(
          v.array(Order),
          orders.map((o) => ({
            createdAt: new Date(o["created_at"]),
            discountCodes: o["discount_codes"],
            id: o["id"].toString(),
          })),
        );
      })
      .catch((unknown: unknown) => {
        console.error(unknown);
        throw unknown;
      });
  };

  return {
    getOrdersUsingCodeWithinDateRange,
  };
};
